import { ref } from "vue";
import { watchDebounced } from "@vueuse/core";
import { useCookies } from "@vueuse/integrations/useCookies";

import { trackEvent } from "@/utils/track-event";

import { type ColumnSizingState } from "@tanstack/vue-table";

export const useMemoDefaultColumnSizing = ({
  key,
  state = {},
  trackingEventCategory = key,
}: {
  key: string;
  state?: ColumnSizingState;
  trackingEventCategory?: string;
}) => {
  const cookies = useCookies();
  const columnSizingFromCookies = cookies.get(key);

  const columnSizeState = ref<ColumnSizingState>(
    columnSizingFromCookies ?? state,
  );

  const memoizeColumnSizing = () => {
    cookies.set(key, columnSizeState.value);
  };

  watchDebounced(
    () => columnSizeState.value,
    () => {
      memoizeColumnSizing();

      trackEvent({
        category: trackingEventCategory,
        action: "Column size changed",
        name: JSON.stringify(columnSizeState.value),
      });
    },
    { debounce: 100, maxWait: 200 },
  );

  return {
    columnSizeState,
  };
};

export default {};
